import React, { useState, useEffect } from 'react';
import { useMediaQuery } from '@/hooks/useMediaQuery';

interface Props {
  empty: React.ReactNode;
  chatPane: React.ReactNode;
  canvasPane: React.ReactNode;
  isEmpty: boolean;
  canvasReady: boolean;
}

export const ChatLayout: React.FC<Props> = ({ empty, chatPane, canvasPane, isEmpty, canvasReady }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [mobileView, setMobileView] = useState<'chat' | 'canvas'>('chat');

  // On mobile: auto-switch to canvas when generation completes, and force
  // back to chat while the canvas has nothing to show (generating / error /
  // post-"Regerar tudo"). Otherwise the user lands on a broken placeholder.
  useEffect(() => {
    if (!isMobile) return;
    setMobileView(canvasReady ? 'canvas' : 'chat');
  }, [isMobile, canvasReady]);

  if (isEmpty) {
    return <div className="h-full min-h-0 flex flex-col overflow-hidden">{empty}</div>;
  }

  if (isMobile) {
    return (
      <div className="h-full min-h-0 flex flex-col overflow-hidden">
        {mobileView === 'chat' ? (
          <div className="h-full min-h-0 flex flex-col">
            {chatPane}
            {canvasReady && (
              <div className="border-t border-border p-2 flex justify-end">
                <button
                  type="button"
                  onClick={() => setMobileView('canvas')}
                  className="text-xs text-primary underline-offset-2 hover:underline"
                >
                  Ver carrossel →
                </button>
              </div>
            )}
          </div>
        ) : (
          <div className="h-full min-h-0 overflow-hidden">
            {React.isValidElement(canvasPane)
              ? React.cloneElement(canvasPane as React.ReactElement<{ onBackOnMobile?: () => void }>, {
                  onBackOnMobile: () => setMobileView('chat'),
                })
              : canvasPane}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="h-full min-h-0 grid grid-cols-[minmax(320px,40%)_1fr] overflow-hidden">
      <div className="h-full min-h-0 border-r border-border flex flex-col overflow-hidden">{chatPane}</div>
      <div className="h-full min-h-0 overflow-hidden">{canvasPane}</div>
    </div>
  );
};
